import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getCheckListSchemaAvailableColumns } from './api';

export const path = '/calculator-tariff/checklist/schema/list';

const PageCheckListSchemaList: React.FC = (props) => {
  const CheckListSchema = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getCheckListSchemaAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <CheckListSchema {...props} />;
};

export default PageCheckListSchemaList;
